import { ENDPOINTS } from 'shared/constants';
import { httpClientAuthorized } from '../httpClient';
import { Faq } from 'shared/types';

export const fetchFaq = async () => {
  return await httpClientAuthorized.get<Faq[]>(ENDPOINTS.FAQ);
};
